document.querySelectorAll('.embedded-page').forEach(async (el) => {
const res = await fetch(el.dataset.embedUrl);
const html = await res.text();
const doc = new DOMParser().parseFromString(html, 'text/html');

// Grab only the template's rendered sections, not header/footer.
// In Dawn and most 2.0 themes this is #MainContent
const main = doc.querySelector('#MainContent, main');
if (!main) return;

el.innerHTML = main.innerHTML;

// Re-execute scripts that came with the sections (innerHTML doesn't run them)
el.querySelectorAll('script').forEach((old) => {
    const s = document.createElement('script');
    [...old.attributes].forEach(a => s.setAttribute(a.name, a.value));
    s.textContent = old.textContent;
    old.replaceWith(s);
});
});
